import React from "react";
import { logger } from "../lib/logger";

// Global error boundary. Wraps the entire application tree.
// Catches synchronous render errors. Async errors must be handled by callers.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    logger.error("ErrorBoundary caught", error?.message, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[#0A0A0A]">
          <div
            className="max-w-md w-full text-center bg-[#1A1A1A] rounded-2xl border border-[#C8A24A]/20 p-8"
            data-testid="error-boundary"
          >
            <p className="text-xs uppercase tracking-[0.2em] text-[#C8A24A] font-semibold mb-3">
              Error inesperado
            </p>
            <h1 className="font-heading text-3xl text-[#C8A24A] mb-3">
              Algo salió mal
            </h1>
            <p className="text-sm text-[#C8A24A]/70 mb-6">
              Ha ocurrido un error inesperado. Puedes recargar la página para continuar.
            </p>
            <button
              onClick={this.handleReload}
              className="px-6 py-3 rounded-xl bg-[#C8A24A] text-[#111111] font-semibold hover:bg-[#B88C2D] transition-colors"
              data-testid="error-boundary-reload"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
